import React from 'react'
import cx from 'classnames'
import { Button, BodyMovin, Div } from '@drifthq/tide-core'

import './style.css'

const SuccessLander = ({ image, headerText, subheaderText, onButtonClick, className = '', buttonText = 'Next', animation, children }) => {
  const bodymovinOptions = {
    loop: true,
    autoplay: true,
    prerender: true,
    renderer: "svg",
    animationData: animation
  }

  return (
    <Div className={cx(`success-lander--root`, `${className}`)}>
    { !!animation ?
      <Div className="success-lander--animation">
        <BodyMovin options={bodymovinOptions} />
      </Div> :
      !!image && <img src={image} alt="rocket"/> }
    <Div className="success-lander--header">{headerText}</Div>
    <Div className="success-lander--subheader"> {subheaderText}</Div>
    {children}
    <Button className="success-lander--button" size="large" onClick={onButtonClick}>
      {buttonText}
    </Button>
  </Div>
  )
}

export default SuccessLander


// WEBPACK FOOTER //
// ./src/components/SuccessLander/index.js